import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";

import ReactGA from "react-ga";

import TopNavigation from "../../components/TopNavigation/TopNavigation";

import FormStart from "../../components/FormStart/FormStart";
import FormSizeOfPlan from "../../components/FormSizeOfPlan/FormSizeOfPlan";
import FormStyleOfPlan from "../../components/FormStyleOfPlan/FormStyleOfPlan";
import FormBenefits from "../../components/FormBenefits/FormBenefits";
import FormChooseMySeats from "../../components/FormChooseMySeats/FormChooseMySeats";
import FormSelectYourSeat from "../../components/FormSelectYourSeat/FormSelectYourSeat";
import Checkout from "../../components/Checkout/Checkout";
import TicketLargeGroup from "../../components/TicketLargeGroup/TicketLargeGroup";
import classes from "./FormBuilder.module.scss";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import "../../Transition/fade.css";

import spinner from "../../assets/images/spinner.gif";

import * as CONSTANT from "../../constants/routes";
import TicketSingleGroup from "../../components/TicketSingleGroup";
import { setType } from "../../features/singleGroup/singleGroupSlice";
import {
  setGames,
  setOpponents,
  setGiveaways,
  setHomeBanner,
} from "../../features/cms/cmsSlice";
import { connect } from "react-redux";
import { CMS } from "../../config";
// import SeatingMap from "../../components/FormSelectYourSeat/SeatingMap";

ReactGA.initialize("UA-71224221-38");
// ReactGA.pageview(window.location.pathname + window.location.search);

class FormBuilder extends Component {
  state = {
    choices: {
      [CONSTANT.PAGE_1_KEY]: ["single", "largeGroup", "package"],
      [CONSTANT.PAGE_2_KEY]: ["classic", "flexible", "ballpark"],
      [CONSTANT.PAGE_3_KEY]: [],
      [CONSTANT.PAGE_4_KEY]: {},
      [CONSTANT.PAGE_5_KEY]: ["recommend", "upsell", "downsell"],
    },
    selectedChoices: {
      [CONSTANT.PAGE_1_KEY]: "",
      [CONSTANT.PAGE_2_KEY]: "",
      [CONSTANT.PAGE_3_KEY]: "",
      [CONSTANT.PAGE_4_KEY]: {},
      [CONSTANT.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      selectedSeats: [],
      numOfSeat: "",
      isRedirect: false,
      checkoutEnable: false,
      planType: "",
    },
    cms: null,
  };

  updateSelectedChoices = (selectedChoicesKey, value) => {
    if (window.adobeAnalytics) {
      if (selectedChoicesKey === "formSize") {
        this.omnitureTracking(value);
      }
    }
    // console.log("here", { [selectedChoicesKey]: value });
    this.setState({
      selectedChoices: {
        ...this.state.selectedChoices,
        [selectedChoicesKey]: value,
      },
    });
  };

  updateMultipleSelectedChoices = (obj) => {
    this.setState({
      selectedChoices: {
        ...this.state.selectedChoices,
        ...obj,
      },
    });
  };

  omnitureTracking = (v) => {
    if (window.adobeAnalytics && window.adobeAnalytics.tl) {
      window.adobeAnalytics.tl(
        true,
        "o",
        `Washington Nationals: Tickets: Nationals Ticketfinder: Size of plan: ${v} : select click`,
        {
          prop12: "Nationals TicketFinder",
          prop13:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Size of plan",
          prop14: `${v} : select click`,
        }
      );
    }
  };

  componentDidMount() {
    const urls = [
      CMS.PACKAGE_API_URL,
      CMS.GAMES_API_URL,
      CMS.OPPONENT_API_URL,
      CMS.GIVEAWAY_API_URL,
      CMS.HOME_BANNER_API_URL,
    ];

    Promise.all(
      urls.map((url) =>
        fetch(url)
          .then(checkStatus)
          .then(parseJSON)
          .catch((error) => console.log("There was a problem!", error))
      )
    ).then((data) => {
      const multiGameCms = data[0];
      const SingleGroupGamesCms = data[1];
      const SingleGroupOpponentsCms = data[2];
      const SingleGroupGiveawaysCms = data[3];
      const homeBannerCms = data[4];

      this.props.setGames(SingleGroupGamesCms?.entries);
      this.props.setOpponents(SingleGroupOpponentsCms?.entries);
      this.props.setGiveaways(SingleGroupGiveawaysCms?.entries);
      this.props.setHomeBanner(homeBannerCms?.entries);
      this.setState({
        cms: multiGameCms?.entries,
      });

      this.createplans();
      //check for any redirect
      var i = setInterval(() => {
        this.urlParamsHandler();
        if (window.redirect) clearInterval(i);
      }, 1000);
      setTimeout(function () {
        clearInterval(i);
      }, 10000);
    });
    function checkStatus(response) {
      if (response.ok) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(new Error(response.statusText));
      }
    }

    function parseJSON(response) {
      return response.json();
    }
  }

  urlParamsHandler() {
    switch (window?.redirect) {
      case "style-of-plan":
        console.log("window?.redirect", window?.redirect);
        this.updateMultipleSelectedChoices({
          formStart: "multiple",
        });
        this.props.history.push("/style-of-plan");
        break;
      // case "size-of-plan/premier":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     planType: "premier",
      //   });
      //   this.props.history.push("/size-of-plan");
      //   break;
      // case "size-of-plan/mini":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     planType: "small",
      //   });
      //   this.props.history.push("/size-of-plan");
      //   break;
      // case "size-of-plan/pickem":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     planType: "pickem",
      //   });
      //   this.props.history.push("/size-of-plan");
      //   break;
      // case "multiple/premier/82/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "eightyClassic",
      //     planType: "premier",
      //     // isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/premier/42/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fortyClassic",
      //     planType: "premier",
      //     // isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/premier/22/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "twentyClassic",
      //     planType: "premier",
      //     // isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/premier/82":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "eightyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "xa79PAlovb",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/premier/42":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fortyClassic",
      //     planType: "premier",
      //     isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/premier/42/a":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fortyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "zN6VE3n0B5",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/premier/42/b":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fortyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "CAFbHgRVNg",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/premier/22":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "twentyClassic",
      //     planType: "premier",
      //     isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/premier/22/abes":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "twentyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "buTMiiX4Er",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/premier/22/georges":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "twentyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "lRcyJMLnKk",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/premier/22/toms":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "twentyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "TLpAWWaMkk",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/premier/22/teddys":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "twentyClassic",
      //     planType: "premier",
      //     selectYourSeatsUuid: "9XZEeo7qMz",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/mini/10":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "tenClassic",
      //     planType: "small",
      //     isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/mini/10/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "tenClassic",
      //     planType: "small",
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/mini/10/opening-day":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "tenClassic",
      //     planType: "small",
      //     selectYourSeatsUuid: "QI48eAMgyD",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/mini/10/big-game":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "tenClassic",
      //     planType: "small",
      //     selectYourSeatsUuid: "cdfSBCw2A9",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/mini/10/sunday":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "tenClassic",
      //     planType: "small",
      //     selectYourSeatsUuid: "bve6L6FYYU",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/mini/5":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fiveClassic",
      //     planType: "small",
      //     isRedirect: true,
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/mini/5/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fiveClassic",
      //     planType: "small",
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/mini/5/bobblehead":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fiveClassic",
      //     planType: "small",
      //     selectYourSeatsUuid: "54C8ZCSb4s",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/mini/5/gear":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fiveClassic",
      //     planType: "small",
      //     selectYourSeatsUuid: "baxawZnlK1",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/mini/5/kids-giveaway":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "classic",
      //     formSize: "fiveClassic",
      //     planType: "small",
      //     selectYourSeatsUuid: "v0C11qgztN",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/pickem/80":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     formSize: "eightyFlexible",
      //     planType: "pickem",
      //     selectYourSeatsUuid: "6WPuBrtT8C",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/pickem/40":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     planType: "pickem",
      //     formSize: "fortyFlexible",
      //     selectYourSeatsUuid: "yHsZtmvU3N",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/pickem/20":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     planType: "pickem",
      //     formSize: "twentyFlexible",
      //     selectYourSeatsUuid: "LHsIqghb0k",
      //     numOfSeat: 1,
      //   });
      //   this.props.history.push("/select-your-seats");
      //   break;
      // case "multiple/pickem/80/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     formSize: "eightyFlexible",
      //     planType: "pickem",
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/pickem/40/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     formSize: "fortyFlexible",
      //     planType: "pickem",
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;
      // case "multiple/pickem/20/recommended":
      //   this.updateMultipleSelectedChoices({
      //     formStart: "multiple",
      //     formStyle: "flexible",
      //     formSize: "twentyFlexible",
      //     planType: "pickem",
      //     selectYourSeatsUuid: "LHsIqghb0k",
      //   });
      //   this.props.history.push("/recommended-plan");
      //   break;

      case "ballpark":
        this.updateMultipleSelectedChoices({
          formStart: "multiple",
          formStyle: "ballpark",
          formSize: "ballPark",
          selectYourSeatsUuid: "soof513JuY",
          numOfSeat: 1,
        });
        this.props.history.push("/select-your-seats");
        break;
      case "ballpark/recommended":
        this.updateMultipleSelectedChoices({
          formStart: "multiple",
          formStyle: "ballpark",
          formSize: "ballPark",
          planType: "ballpark",
          // isRedirect: true,
        });
        this.props.history.push("/recommended-plan");
        break;
      // case "group":
      //   this.props.history.push("/ticket-group-home");
      //   break;
      // case "group/choose-your-own-adventure":
      //   this.props.setType("group");
      //   this.props.history.push("/ticket-single-group");
      //   break;
      // case "single/choose-your-own-adventure":
      //   this.props.setType("single");
      //   this.props.history.push("/ticket-single-group");
      //   break;
      default:
        break;
    }
  }
  async createplans() {
    if (this.state.cms) {
      const _exclusivity = [];
      const _savings = [];
      const _convenience = [];
      const cms = this.state.cms;

      await cms.forEach(async (style, index) => {
        await style.plans.forEach(async (plan) => {
          if (
            !plan.pageExclusivity ||
            !plan.pageSavings ||
            !plan.pageConvenience
          )
            return;
          const _planName =
            plan.sizePlanChoice === "eightyBallpark"
              ? "ballPark"
              : plan.sizePlanChoice;

          plan.pageExclusivity.forEach((benefit) => {
            const exclusivityMatch = _exclusivity.filter(function (e) {
              return e.label === benefit.name;
            });

            if (exclusivityMatch.length > 0) {
              const index = _exclusivity.findIndex(function (entry) {
                return entry.label === exclusivityMatch[0].label;
              });
              _exclusivity[index].show.push(
                `${_planName}-${style.name.toLowerCase()}`
              );
            } else {
              _exclusivity.push({
                label: benefit.name,
                selected: false,
                show: [`${_planName}-${style.name.toLowerCase()}`],
              });
            }
          });

          plan.pageSavings.forEach((benefit) => {
            const savingsMatch = _savings.filter(function (e) {
              return e.label === benefit.name;
            });

            if (savingsMatch.length > 0) {
              const index = _savings.findIndex(function (entry) {
                return entry.label === savingsMatch[0].label;
              });
              _savings[index].show.push(
                `${_planName}-${style.name.toLowerCase()}`
              );
            } else {
              _savings.push({
                label: benefit.name,
                selected: false,
                show: [`${_planName}-${style.name.toLowerCase()}`],
              });
            }
          });

          plan.pageConvenience.forEach((benefit) => {
            const convenienceMatch = _convenience.filter(function (e) {
              return e.label === benefit.name;
            });

            if (convenienceMatch.length > 0) {
              const index = _convenience.findIndex(function (entry) {
                return entry.label === convenienceMatch[0].label;
              });
              _convenience[index].show.push(
                `${_planName}-${style.name.toLowerCase()}`
              );
            } else {
              _convenience.push({
                label: benefit.name,
                selected: false,
                show: [`${_planName}-${style.name.toLowerCase()}`],
              });
            }
          });
        });
      });

      // itemsArray.sort(function(a, b){
      //   return sortingArr.indexOf(a) - sortingArr.indexOf(b);
      // });

      // console.log('_convenience', _convenience);

      this.setState({
        benefits: {
          exclusivity: _exclusivity,
          savings: _savings,
          convenience: _convenience,
        },
      });
    }
  }

  render() {
    return (
      <div className={classes.FormBuilder}>
        <TopNavigation data={this.state} />
        {!this.state.cms ||
        !this.state.benefits ||
        !this.state.benefits.exclusivity ||
        !this.state.benefits.savings ||
        !this.state.benefits.convenience ? (
          <div className={classes.loader}>
            <img src={spinner} alt="" />
            <span>Loading ...</span>
          </div>
        ) : (
          <div className={classes.content}>
            <Route
              render={({ location }) => (
                <TransitionGroup>
                  <CSSTransition
                    key={location.key}
                    timeout={500}
                    classNames="fade"
                    unmountOnExit
                  >
                    <Switch location={location}>
                      <Route
                        path="/"
                        exact
                        children={
                          <FormStart
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                          />
                        }
                      />
                      <Route
                        path="/ticket-large-group"
                        children={<TicketLargeGroup />}
                      />
                      <Route
                        path="/ticket-single-group"
                        children={<TicketSingleGroup />}
                      />
                      <Route
                        path="/ticket-group-home"
                        children={<TicketSingleGroup />}
                      />
                      <Route
                        path="/style-of-plan"
                        children={
                          <FormStyleOfPlan
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                          />
                        }
                      />
                      <Route
                        path="/size-of-plan"
                        children={
                          <FormSizeOfPlan
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            cms={this.state.cms}
                          />
                        }
                      />
                      <Route
                        path="/benefits"
                        children={
                          <FormBenefits
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            benefits={{
                              exclusivity: this.state.benefits.exclusivity,
                              savings: this.state.benefits.savings,
                              convenience: this.state.benefits.convenience,
                            }}
                            cms={this.state.cms}
                          />
                        }
                      />
                      <Route
                        path="/recommended-plan"
                        children={
                          <FormChooseMySeats
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            cms={this.state.cms}
                          />
                        }
                      />
                      <Route
                        path="/select-your-seats"
                        children={
                          <FormSelectYourSeat
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            updateMultipleSelectedChoices={
                              this.updateMultipleSelectedChoices
                            }
                            cms={this.state.cms}
                          />
                        }
                      />
                      <Route
                        path="/checkout"
                        children={
                          <Checkout
                            {...this.state.selectedChoices}
                            updateSelectedChoices={this.updateSelectedChoices}
                            cms={this.state.cms}
                          />
                        }
                      />
                    </Switch>
                  </CSSTransition>
                </TransitionGroup>
              )}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setGames: (games) => dispatch(setGames(games)),
    setType: (type) => dispatch(setType(type)),
    setOpponents: (opponents) => dispatch(setOpponents(opponents)),
    setGiveaways: (giveaways) => dispatch(setGiveaways(giveaways)),
    setHomeBanner: (homeBanner) => dispatch(setHomeBanner(homeBanner)),
  };
};

const compWithRouter = withRouter(FormBuilder);
export default connect(null, mapDispatchToProps)(compWithRouter);
// export default withRouter(FormBuilder);
